import script from "./new-view-loading.vue?vue&type=script&setup=true&lang=js"
export * from "./new-view-loading.vue?vue&type=script&setup=true&lang=js"

import "./new-view-loading.vue?vue&type=style&index=0&id=85146056&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85146056"]])

export default __exports__